const sanityClient = require('@sanity/client')
const client = sanityClient({
  projectId: 't2oi6lex',
  dataset: 'production',
  useCdn: true // `false` if you want to ensure fresh data
})

export default client 